"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'LotDetailVenteInitiale',
  props: ['idLot', 'listeDeboursesIndirects'],
  data: function data() {
    return {
      email: '',
      lotsDetail: [],
      calculs: [],
      totaux: [],
      modeEdit: false,
      checkValidation: false,
      rowsForCanceling: [],
      rowsForSaving: [],
      // pour mémoriser uniquement les lignes modifiées et éviter de tout sauvegarder
      refresh: 0,
      refreshList: 0,
      listValues: []
    };
  },
  created: function created() {
    var _this = this;

    this.$watch('$root.modeEdit', function (newValue) {
      if (newValue === false) {
        _this.modeEdit = false;
      }
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.listValues = this.listeDeboursesIndirects;

    _eventBus.EventBus.$on('EDIT_LOT', function (idLot) {
      if (_this2.idLot === idLot) {
        _this2.modeEdit = true;
        _this2.rowsForCanceling = JSON.parse(JSON.stringify(_this2.lotsDetail));
        _this2.rowsForSaving = [];

        _eventBus.EventBus.$emit('MODE_EDIT', true);
      }
    });

    _eventBus.EventBus.$on('REFRESH', function () {
      // ------------
      _this2.lotsDetail = _this2.$store.getters.affaire.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && x.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE;
      });
      _this2.calculs = _this2.$store.getters.affaire.calculs.lotsDetail.filter(function (x) {
        return x.id_lot === _this2.idLot && x.type_lot_detail === CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE;
      });
      _this2.totaux = _this2.$store.getters.affaire.calculs.lots.filter(function (x) {
        return x.id === _this2.idLot;
      });
    });

    _eventBus.EventBus.$on('REFRESH_LIBELLE_LIST', function () {
      _this2.refreshLibelleList();
    });

    this.refresh++;
    this.refreshLibelleList();
  },
  beforeDestroy: function beforeDestroy() {
    _eventBus.EventBus.$off('EDIT_LOT');

    _eventBus.EventBus.$off('REFRESH');

    _eventBus.EventBus.$off('REFRESH_LIBELLE_LIST');
  },
  methods: {
    autoListValues: function autoListValues(_, cb) {
      cb(this.listValues);
    },
    isValidData: function isValidData() {
      // on controle si le libellé de la ligne est renseigné
      var rows = this.$refs['dataTable'].tableData;
      var err = false;

      for (var i = 0; i < rows.length; i++) {
        if (rows[i].libelle.trim() === '') {
          err = true;
        }
      }

      this.checkValidation = err;
      return !err;
    },
    handleSelect: function handleSelect(scope) {
      var item = this.listValues.find(function (x) {
        return x.value === scope.row.libelle;
      });
      scope.row.id_debourseIndirect = item ? item.id_debourseIndirect : 0;
    },
    handleDrop: function handleDrop(e) {
      var _this3 = this;

      e.list.forEach(function (row, index) {
        var idx = index + 1;

        if (row.ordre !== idx) {
          row.ordre = idx;

          _this3.$store.dispatch('affaire/setLotDetail', row).then(function () {
            if (_this3.rowsForSaving.indexOf(row.id) === -1) {
              _this3.rowsForSaving.push(row.id);
            }
          });
        }
      });
    },
    refreshLibelleList: function () {
      var _refreshLibelleList = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this4 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.listValues.forEach(function (row, index) {
                  var idx = _this4.$store.getters.affaire.lotsDetail.findIndex(function (x) {
                    return x.libelle === row.value;
                  });

                  _this4.listValues[index].show = idx < 0;
                });

              case 2:
                this.refreshList++;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function refreshLibelleList() {
        return _refreshLibelleList.apply(this, arguments);
      }

      return refreshLibelleList;
    }(),
    handleInput: function handleInput(scope, action) {
      // on force la valeur du montant à null si aucune valeur saisie (evite plantage en Bdd valeur chaine vide dans champ numérique)
      if (scope.row.mt_debourse_etude === '') {
        scope.row.mt_debourse_etude = null;
      } // on initialise le montant de derniere proposition prestataire à partir du montant de debourse etude pour l'écran de Budget Affaire


      scope.row.mt_proposition_prestataire = scope.row.mt_debourse_etude; // si la valeur du champ Libellé change

      if (scope.column.property === 'libelle') {
        // on remet à jour le contenu de la liste d'autocompletion
        _eventBus.EventBus.$emit('REFRESH_LIBELLE_LIST'); // on remt à jour la valeur du champ caché flag_indent


        this.handleSelect(scope);
      } // mémorisation de la ligne modifiée pour ne sauvegarder + tard que celles concernées
      // et pas toutes les lignes de lotsDetail (on optimise le nombre de requete sql à faire)


      if (this.rowsForSaving.indexOf(scope.row.id) === -1) {
        this.rowsForSaving.push(scope.row.id);
      }

      this.$store.dispatch('affaire/setLotDetail', scope.row).then(function () {
        if (action === 'refresh_calcul') {
          _eventBus.EventBus.$emit('REFRESH_CALCULS');
        }
      });
    },
    handleAdd: function handleAdd() {
      this.handleSave();
      var row = {
        id_lot: this.idLot,
        libelle: '',
        prestataire: '',
        mt_vente_initiale: null,
        mt_debourse_etude: null,
        type_lot_detail: CONST.LOT_DETAIL.TYPE_LIGNE.INITIALE,
        ordre: Math.max.apply(Math, _toConsumableArray(this.lotsDetail.map(function (o) {
          return o.ordre;
        })).concat([0])) + 1,
        id_debourseIndirect: 0
      };
      this.action('insertLotDetail', row);
      this.modeEdit = true;

      _eventBus.EventBus.$emit('MODE_EDIT', true);
    },
    handleDelete: function handleDelete(scope) {
      var _this5 = this;

      var msg = 'Voulez-vous supprimer cette ligne ?';
      this.$confirm(msg, 'Confirmation', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        type: 'warning',
        closeOnClickModal: false
      }).then(function () {
        _this5.action('deleteLotDetail', scope.row);

        var index = _this5.rowsForSaving.findIndex(function (id) {
          return id === scope.row.id;
        });

        if (index > -1) {
          _this5.rowsForSaving.splice(index, 1);
        }
      });
    },
    handleCancel: function handleCancel() {
      var _this6 = this;

      if (this.isValidData()) {
        this.modeEdit = false;
        var rows = this.rowsForCanceling;
        rows.forEach(function (row, index) {
          _this6.$store.dispatch('affaire/setLotDetail', row);
        });
        this.rowsForCanceling = [];
        this.rowsForSaving = [];

        _eventBus.EventBus.$emit('REFRESH_CALCULS');

        _eventBus.EventBus.$emit('MODE_EDIT', false);
      }
    },
    handleSave: function handleSave() {
      var _this7 = this;

      if (this.isValidData()) {
        this.modeEdit = false;

        var _loop = function _loop(i) {
          var index = _this7.lotsDetail.findIndex(function (row) {
            return row.id === _this7.rowsForSaving[i];
          });

          if (index > -1) {
            _this7.action('updateLotDetail', _this7.lotsDetail[index]);
          }
        };

        for (var i = 0; i < this.rowsForSaving.length; i++) {
          _loop(i);
        }

        _eventBus.EventBus.$emit('MODE_EDIT', false);
      }
    },
    // -----------------------------------------------
    action: function action(_action, lotdetail) {
      var _this8 = this;

      // console.log(action, lotdetail)
      this.$store.dispatch('affaire/' + _action, lotdetail).then(function () {
        _this8.$store.dispatch('affaire/setLotDetail', lotdetail).then(function () {
          _eventBus.EventBus.$emit('REFRESH_CALCULS'); // on remet à jour le contenu de la liste d'autocompletion


          _eventBus.EventBus.$emit('REFRESH_LIBELLE_LIST');
        });
      }).catch(function (error) {
        _this8.$message(error);
      });
    }
  }
};
exports.default = _default;